import { POST_TYPE_KEY, platformFeatures } from '../config/platformFeatures';

export const postExcededTextLimit = (
  platform: string,
  postType: string,
  length: number
) => {
  const limit = getPostLimit(platform, postType);
  if (!limit) return false;
  return length > limit;
};
export const getPostLimit = (platform: string, postType: string) => {
  if (!platformFeatures[platform]) return 1000;
  return platformFeatures[platform][POST_TYPE_KEY].find(
    (config: any) => config.typeKey === postType
  )?.maxTextLength;
};
